var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOfficialavatar = function SvgOfficialavatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none",
    viewBox: "-10 -10 57 57"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M22.878 34.142c6.902-.483 12.4-6.353 12.853-13.72a36 36 0 0 0 0-4.378c-.453-7.368-5.95-13.237-12.853-13.72a52 52 0 0 0-7.163 0c-6.902.483-12.4 6.352-12.852 13.72a36 36 0 0 0 0 4.377c.165 2.684 1.293 5.169 2.62 7.267.77 1.469.262 3.302-.54 4.903-.58 1.155-.869 1.732-.637 2.15.233.416.752.43 1.79.456 2.053.053 3.437-.56 4.536-1.413.623-.484.935-.726 1.15-.753s.637.155 1.483.521c.76.33 1.641.533 2.45.59 2.35.164 4.809.164 7.163 0Z"
  })));
};
export default SvgOfficialavatar;